import React from 'react';
import { List } from 'core/route';
import { columns } from './columns';

export function Groups(): React.ReactElement {
  return <List columns={columns} url="security/groups/" />;
}
